import { EnrollmentTaxFilingStatusType } from '@egw/api/src/models/enrollment/enrollment'
import { Button, Field, ModalDrawer, RadioGroup, useModalState } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { FC, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

// Compononent to Be used within a FormProvider from react-hook-form
export const EditTaxFiling: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { openModal, closeModal, isOpen } = useModalState()
  const [defaultTaxFilingStatus, setDefaultTaxFilingStatus] = useState<EnrollmentTaxFilingStatusType | undefined>(
    undefined,
  )

  const { control, watch, setValue } = useFormContext()

  const taxFilingStatus = watch('taxFilingStatus')

  useEffect(() => {
    if (taxFilingStatus !== undefined && defaultTaxFilingStatus === undefined) {
      setDefaultTaxFilingStatus(taxFilingStatus)
    }
  }, [taxFilingStatus])

  // Closes the modal and reverts the value to the default value
  // Only using the closeModal method will persist the value
  const closeWithoutSaving = () => {
    setValue('taxFilingStatus', defaultTaxFilingStatus)
    closeModal()
  }

  // Sets the new default value for future edits
  const closeWithSaving = () => {
    setDefaultTaxFilingStatus(taxFilingStatus)
    closeModal()
  }

  return (
    <>
      <Field
        className="border-b py-sm"
        valueClassName="text-text-meta typo-primary-base-regular"
        value={t('edit_fields.tax_filing_status_title')}
        rightValue={t(`tax_filing_status.${taxFilingStatus}`)}
        testId={'editIsBrokerDealer'}
        onEdit={openModal}
      />
      <ModalDrawer isOpen={isOpen} onClose={closeWithoutSaving} title={t('edit_fields.edit_tax_filing_status')}>
        <>
          <p className="typo-primary-base-semibold text-text-header mb-sm">
            {t('multi.finances.tax_filing_status_title')}
          </p>
          <Controller
            name="taxFilingStatus"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { ref, ...restField } }) => (
              <RadioGroup
                {...restField}
                options={Object.values(EnrollmentTaxFilingStatusType).map((item) => ({
                  value: item,
                  label: t(`tax_filing_status.${item}`),
                }))}
                name="taxFilingStatus"
                className="pb-md typo-primary-base"
                testId="tax-filing-status-radio"
              />
            )}
          />
          <Button size="small" onClick={closeWithSaving} className="w-full mt-lg" testId="primaryAction_button">
            {t('common.confirm')}
          </Button>
        </>
      </ModalDrawer>
    </>
  )
}
